export type AccessStatus = 'REQUESTED' | 'GRANTED';
export const AccessStatus = {
  REQUESTED: 'REQUESTED' as AccessStatus,
  GRANTED: 'GRANTED' as AccessStatus,
};
